<template>
  <div class="dsf_search_column">
    <div class="item_inner" @click="toDetail(data)">
      <div class="item-left-img">
        <dsf-image :src="data['cover'] | imgFormat" :error-src="dsf.config.setting_nc_image_default_img" />
        <span class="item-type">{{ data.typename || "直播" }}</span>
      </div>
      <div class="item-right-desc">
        <div class="title">
          <span class="name ellipsis-2">{{ data.title }}</span>
        </div>
        <p class="item-exam-rule">
          <!-- <span>考试总分: {{ data.score }}分</span>
          <span>及格总分: {{ data.pass_score }}分</span> -->
        </p>
        <ul class="item-bottom-desc"></ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "dsfSearchLiveColumn",
  ctrlCaption: "直播",
  props: {
    // 跳转方式
    clickConfig: {
      type: Object,
      default: null,
    },
    detailUrl: {
      type: String,
      default: "/page.html#/pc/nc/pagelive/liveDetail?id=",
    },
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    curColor() {
      return this.$root.currentTheme["normal"];
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    toDetail(item) {
      if (this.$listeners["click"]) {
        this.$dispatch("click", item);
      } else {
        if (this.detailUrl) {
          // let url = this.$replace(this.detailUrl, this.data);
          // this.$openWindow({ url: url });
          dsf.layer.openWindow(this.detailUrl + item.id);
        }
      }
    },
  },
};
</script>
